exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._LSV0ycv-V1U9122rajwq{cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"clickable": "_LSV0ycv-V1U9122rajwq"
};